import script from "./FastbookingButton.vue?vue&type=script&setup=true&lang=js"
export * from "./FastbookingButton.vue?vue&type=script&setup=true&lang=js"

import "./FastbookingButton.vue?vue&type=style&index=0&id=4bd5a978&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bd5a978"]])

export default __exports__